import { __rest } from "tslib";
import React from "react";
import { View } from "react-native";
import { PnmacNavigation, PnmacHtmlToNative } from "pnmac-universal-components";
import { TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, TrackerHitTypeLID_ENUM, UserLanguage_ENUM } from "../../redux/events/events";
import moment from 'moment';
import { currencyFormatterWithoutSign } from '../../utils.js';
import BannerView from '../../v2/BannerView';
var EscrowAnalysisFooterBanner = function (_a) {
  var _b, _c, _d;
  var matches = _a.matches,
    translations = _a.translations,
    props = __rest(_a, ["matches", "translations"]);
  var lookBackDataLatest = props.layout.escrowAnalysisLookBackData.length > 0 ? props.layout.escrowAnalysisLookBackData[0] : [];
  var monthBeforeNewPaymentEffectiveDate = (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.newPaymentEffectiveDate) ? moment(lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.newPaymentEffectiveDate).format('MMMM D, YYYY') : "N/A";
  var totalpaymentafterfullshortage = (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.totalPaymentAfterFullShortage) ? currencyFormatterWithoutSign('en-US', 'currency', 'USD', Math.abs(lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.totalPaymentAfterFullShortage)) : "N/A";
  var escrowShortageorOverageAmount = (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.escrowShortageorOverageAmount) ? currencyFormatterWithoutSign('en-US', 'currency', 'USD', Math.abs(lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.escrowShortageorOverageAmount)) : "N/A";
  var information1 = (_d = (_c = (_b = translations === null || translations === void 0 ? void 0 : translations.EAPFooterDetails) === null || _b === void 0 ? void 0 : _b.replace("{0}", escrowShortageorOverageAmount)) === null || _c === void 0 ? void 0 : _c.replace("{1}", monthBeforeNewPaymentEffectiveDate)) === null || _d === void 0 ? void 0 : _d.replace("{2}", totalpaymentafterfullshortage);
  var escrowShortageorOverageAmountIsZero = (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.escrowShortageorOverageAmount) === 0 || (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.escrowShortageorOverageAmount) === 0.0;
  var finalInfoText = escrowShortageorOverageAmountIsZero ? translations.EAPInformation4 : information1;
  return /*#__PURE__*/React.createElement(View, {
    style: {
      marginTop: 10
    }
  }, /*#__PURE__*/React.createElement(BannerView, {
    style: {
      marginBottom: 10
    }
  }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
    onClick: function (e) {
      var target = e.target.toString();
      if (target != null && target.indexOf('/Payment') > -1) {
        props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Escrow Payment Change Button Clicked", 0);
      }
    },
    value: finalInfoText,
    navigation: {
      navigate: function () {
        props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Escrow Payment Change Button Clicked", 0);
        props === null || props === void 0 ? void 0 : props.navigation.navigate('PaymentsBTN', {
          screen: 'PaymentsBTN',
          initial: false
        });
      }
    }
  })), /*#__PURE__*/React.createElement(BannerView, {
    style: {
      marginBottom: 10
    }
  }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
    value: translations.EAPNotApplicable
  })));
};
export default EscrowAnalysisFooterBanner;